import axios from "axios";

const apiInstance1 = axios.create({
  //baseURL: "http://localhost:3802/api/v1",
  baseURL: "https://www.app-whatsivo.com:3802/api/v1",
});

//Esto es para la consulta de datos
const apiInstance2 = axios.create({
  baseURL: 'https://apps.whatsivo.com/datos/api/v1',
  //baseURL: 'http://localhost:3000/api/v1',
});

export { apiInstance1, apiInstance2 };